function setSVGDimensions(el) {
    let svg = el.find('svg')
    let rect = el.find('rect')
    let elementWidth = el.width()
    let elementHeight = el.height()

    if (elementWidth > 0) {
        svg.css({
            width: elementWidth + 10,
            height: elementHeight + 10,
        })

        rect.css({
            width: elementWidth + 10,
            height: elementHeight + 10,
        })
    }
}

function navHoverIn(el) {
    let boxHeight = el.find('svg rect').height()
    let boxWidth = el.find('svg rect').width()
    let boxPerimeter = (boxHeight * 2) + (boxWidth *2)
    const strokelength = 26

    let strokeOffset = boxHeight + (boxWidth / 2) + (strokelength / 2)

    el.find('svg rect').css({
        strokeWidth: 3,
        strokeDasharray: `${strokelength}, ${boxPerimeter - strokelength}`,
        strokeDashoffset: strokeOffset,
        transition: 'all 1.35s cubic-bezier(0.19, 1, 0.22, 1)',
    })
}

function navHoverOut(el) {
    el.find('svg rect').css({
        strokeWidth: '',
        strokeDasharray: '',
        strokeDashoffset: '',
        transition: '',
    })
}

$('.ll-header-desktop .ll-menu-item--is-top').hover(function () {
    const el = $(this)
    setSVGDimensions(el)
    navHoverIn(el)
}, function () {
    const el = $(this)
    navHoverOut(el)
})

$(window).on('load', function () {
    const navItems = $('.ll-header-desktop .ll-menu-item--is-top')
    navItems.each(function () {
        let navItem = $(this)
        setSVGDimensions(navItem)
    })
})



// WEBPACK FOOTER //
// ./scripts/headerDesktop.js